<template>
  <div>
    <div class="page-title underline mb-5"><mdb-icon icon="highlighter" /> 성취도 평가</div>
    <stduent-summary />
  </div>
</template>
<script>
import { mdbTabs } from 'mdbvue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import FolderLabel from '@/components/common/FolderLabel.vue';
import StduentSummary from '../../../components/summary/StduentSummary.vue';
export default {
  components: { StduentSummary },
  name: 'StudentTestSummaryPage',
  props: [],
  data: () => ({
  }),
  computed: {
    ...mapState('auth', ['profile'])
  },
  methods: {
    onActiveTab (index) {
    }
  },
  watch: {
  }
}
</script>
